import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import LayoutKasir from './layoutKasir';
import { Reservasi } from '../reservasi/Reservasi';
import { Logout, reset } from '../../fitur/AuthSlice';

/** Reservasi di layar kasir: halaman yang sama dengan web admin, di dalam sidebar kasir. */
const ReservasiKasir = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <LayoutKasir onNavigate={(p) => navigate(p)} onLogout={() => { dispatch(reset()); dispatch(Logout()); navigate('/'); }}>
      <Reservasi />
    </LayoutKasir>
  );
};

export default ReservasiKasir;
